import { SocketIOState } from "./types";
export const defaultState = (): SocketIOState => {
  return {
    authenticated: false
  };
};

export const state = defaultState();
